import React from 'react';

import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  VStack,
  Text,
  Badge,
} from '@chakra-ui/react';

import { DetailField, DetailSection } from './DetailField';
import { useColors } from './colors';
import { formatMoney, formatOrderDate } from '../../utils/orderStatus.util';

const PaymentTab = ({ order }) => {
  const { borderColor, headerBg, textColor, subTextColor, cardBg } = useColors();
  const isEbay = order.marketplace === 'ebay';

  if (isEbay) {
    const ps = order.pricingSummary || {};
    const pay = order.paymentSummary || {};

    return (
      <VStack align="stretch" spacing={5}>
        <DetailSection title="Pricing summary (eBay)">
          <DetailField
            label="Subtotal"
            value={formatMoney(ps.priceSubtotal?.value, ps.priceSubtotal?.currency)}
          />
          <DetailField
            label="Delivery"
            value={formatMoney(ps.deliveryCost?.value, ps.deliveryCost?.currency)}
          />
          <DetailField label="Tax" value={formatMoney(ps.tax?.value, ps.tax?.currency)} />
          <DetailField
            label="Order total"
            value={formatMoney(ps.total?.value, ps.total?.currency)}
          />
        </DetailSection>

        <DetailSection title="Seller proceeds">
          <DetailField
            label="Total due seller"
            value={formatMoney(pay.totalDueSeller?.value, pay.totalDueSeller?.currency)}
          />
        </DetailSection>

        {pay.payments?.length > 0 && (
          <Box
            bg={cardBg}
            borderWidth="1px"
            borderColor={borderColor}
            borderRadius="lg"
            overflowX="auto"
          >
            <Text fontWeight="semibold" p={4} pb={2} color={textColor} fontSize="md">
              Payments
            </Text>
            <Table size="sm">
              <Thead bg={headerBg}>
                <Tr>
                  <Th>Method</Th>
                  <Th>Date</Th>
                  <Th isNumeric>Amount</Th>
                  <Th>Status</Th>
                </Tr>
              </Thead>
              <Tbody>
                {pay.payments.map((p, i) => (
                  <Tr key={i}>
                    <Td>{p.paymentMethod}</Td>
                    <Td fontSize="xs">{formatOrderDate(p.paymentDate)}</Td>
                    <Td isNumeric fontWeight="semibold">
                      {formatMoney(p.amount?.value, p.amount?.currency)}
                    </Td>
                    <Td>
                      <Badge colorScheme="green" variant="subtle">
                        {p.paymentStatus}
                      </Badge>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        )}

        {pay.refunds?.length > 0 ? (
          <Text fontSize="sm" color={subTextColor}>
            Refunds recorded: {pay.refunds.length}
          </Text>
        ) : (
          <Text fontSize="sm" color={subTextColor}>
            No refunds on this order.
          </Text>
        )}
      </VStack>
    );
  }

  const ps = order.pricingSummary || {};
  const pay = order.paymentSummary || {};

  return (
    <VStack align="stretch" spacing={5}>
      <DetailSection title="Order totals (Amazon)">
        <DetailField
          label="Order total"
          value={formatMoney(ps.total?.value, ps.total?.currency)}
        />
        <DetailField
          label="Subtotal"
          value={formatMoney(ps.priceSubtotal?.value, ps.priceSubtotal?.currency)}
        />
      </DetailSection>

      {pay.payments?.length > 0 && (
        <Box
          bg={cardBg}
          borderWidth="1px"
          borderColor={borderColor}
          borderRadius="lg"
          overflowX="auto"
        >
          <Text fontWeight="semibold" p={4} pb={2} color={textColor} fontSize="md">
            Payments
          </Text>
          <Table size="sm">
            <Thead bg={headerBg}>
              <Tr>
                <Th>Method</Th>
                <Th isNumeric>Amount</Th>
                <Th>Status</Th>
              </Tr>
            </Thead>
            <Tbody>
              {pay.payments.map((p, i) => (
                <Tr key={i}>
                  <Td>{p.paymentMethod}</Td>
                  <Td isNumeric fontWeight="semibold">
                    {formatMoney(p.amount?.value, p.amount?.currency)}
                  </Td>
                  <Td>
                    <Badge colorScheme="green" variant="subtle">
                      {p.paymentStatus}
                    </Badge>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </VStack>
  );
};

export default PaymentTab;
